/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a bug`)
};

const es_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar de un error`)
};

const de_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler melden`)
};

const nl_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug melden`)
};

const fr_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler un bug`)
};

const it_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnala un bug`)
};

const pt_br2_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatar um bug`)
};

const pt_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar um erro`)
};

const ja_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バグを報告`)
};

const zh_contact_type_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报告 bug`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_type_bug = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_type_bug(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_type_bug", locale)
	if (locale === "en") return en_contact_type_bug(inputs)
	if (locale === "es") return es_contact_type_bug(inputs)
	if (locale === "de") return de_contact_type_bug(inputs)
	if (locale === "nl") return nl_contact_type_bug(inputs)
	if (locale === "fr") return fr_contact_type_bug(inputs)
	if (locale === "it") return it_contact_type_bug(inputs)
	if (locale === "pt-BR") return pt_br2_contact_type_bug(inputs)
	if (locale === "pt") return pt_contact_type_bug(inputs)
	if (locale === "ja") return ja_contact_type_bug(inputs)
	return zh_contact_type_bug(inputs)
};